import { render, staticRenderFns } from "./NewSimple.vue?vue&type=template&id=7590d991&scoped=true&"
import script from "./NewSimple.vue?vue&type=script&lang=js&"
export * from "./NewSimple.vue?vue&type=script&lang=js&"
import style0 from "./NewSimple.vue?vue&type=style&index=0&id=7590d991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590d991",
  null
  
)

export default component.exports